import React from 'react';
import { FunctionFactory } from 'survey-core';

const injuriesSplashHtml = `
<div class="new-quote-container centered"> 
  <div class="splash-icon">{injuriesIcon}</div>
  <div class="splash-header">
    <h1>{injuriesTitle}</h1>
    <div class="quote">
      {injuriesQuote}
    </div>
  </div>
</div>`;

const injuriesSplashExpression = {
  name: "injuriesQuote",
  expression: "renderInjuriesQuote({injuries})",
};

function renderInjuriesQuote(params: any[]): string {
  if (params === undefined || params === null || params.length === 0) return "";
  if (params[0]?.[0] === "none") {
    return `That’s awesome. We’ll help you stay injury-free with smart workouts that build strength while protecting your joints and mobility.`;
  } 
  return `Injuries are more common than you think. We’ll help you work around them so they don’t hold you back, and include a simple routine that can support your recovery, too.`;
}

FunctionFactory.Instance.register("renderInjuriesQuote", renderInjuriesQuote);

function renderInjuriesIcon(params: any[]): string {
  if (params === undefined || params === null || params.length === 0) return "";
  if (params[0]?.[0] === "none") {
    return `💪`;
  } 
  return `🛠️`;
}

FunctionFactory.Instance.register("renderInjuriesIcon", renderInjuriesIcon);

const injuriesSplashIconExpression = {
  name: "injuriesIcon",
  expression: "renderInjuriesIcon({injuries})",
};

function renderInjuriesTitle(params: any[]): string {
  if (params === undefined || params === null || params.length === 0) return "";
  if (params[0]?.[0] === "none") {
    return `Let’s keep it that way.`;
  } 
  return `You’re in good hands.`;
}

FunctionFactory.Instance.register("renderInjuriesTitle", renderInjuriesTitle);

const injuriesSplashTitleExpression = {
  name: "injuriesTitle",
  expression: "renderInjuriesTitle({injuries})",
};

const injuriesSplashElement = {
  name: 'injuries-splash',
  type: 'html',
  html: injuriesSplashHtml,
}

const InjuriesSplashHeader = () => {
  return (
    <div style={{
      padding: "8px 0 5px 0",
      background: "white",
      textAlign: "center",
      color: "#7A7A7A",
      fontSize: "12px", 
    }}>
      🏁 Final lap – dialling in the details
    </div>
  )
}

export {
  injuriesSplashElement,
  injuriesSplashExpression,
  InjuriesSplashHeader,
  injuriesSplashIconExpression,
  injuriesSplashTitleExpression,
}
